export default __webpack_public_path__ + "static/background-box1-7300297282766c36821dfc3d6f758475.svg";